export const breadcrumb = {
  title: 'Предиктивный обзвон',

  campaign: {
    index: 'Кампании',
    edit: 'Редактировать кампанию',
    new: 'Добавить кампанию'
  },

  webhook: {
    index: 'Вебхуки'
  },
  
  settings: {
    index: 'Настройки'
  },
  
  products: {
    index: 'Продукты'
  },

  operators: {
    index: 'Операторы',
    edit: 'Редактировать операторов',
    new: 'Добавить операторов'
  },

  task: {
    index: 'Список задач кампании {name}',
    edit: 'Редактировать задачи',
    new: 'Добавить задачи'
  },

  monitoring: {
    index: 'Мониторинг кампании {name}'
  },

  monitoring_general: {
    index: 'Мониторинг кампании {name}'
  }
};
